<template>
  <div class="container-fluid m-0 p-0">
    <div class="row text-left bg-light border-bottom py-3 d-flex justify-content-between">
      <div class="col-auto">
        <h5 class="mb-0 font-weight-bold">List of Available Crew</h5>
      </div>
      <div class="col-auto">
        <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                @click="goBack"
        >
          <span class="fas fa-backward"></span>
          Go Back
        </button>
      </div>
    </div>

    <div class="row py-2">
      <div class="col-10 text-left">
        <div class="form-inline d-flex justify-content-start w-100">
          <div class="form-group py-1 mx-3">
            <label for="onboardFrom" class="form-control-xs font-weight-bold">
              Date From:
            </label>
            <input type="date" id="onboardFrom" class="form-control form-control-xs mx-2"
                   v-model="params.date_from" :disabled="isLoading">
          </div>
          <div class="form-group py-1 mx-3">
            <label for="onboardTo" class="form-control-xs font-weight-bold">
              Date To:
            </label>
            <input type="date" id="onboardTo" class="form-control form-control-xs mx-2"
                   v-model="params.date_to" :disabled="isLoading">
          </div>
          <div class="form-group mx-3" v-if="isPrincipal">
            <label for="manning" class="form-control-xs font-weight-bold">Select Manning: </label>
            <select name="manning" id="manning" class="form-control form-control-xs mx-2"
                    v-model="params.manning_id" :disabled="isLoading">
              <option :value="null" id="manningOption0" disabled selected>---Select Manning ---</option>
              <option :value="0">ALL MANNING</option>
              <option v-for="manningKey in getManningLists"
                      :key="manningKey.id"
                      :title="manningKey.name"
                      :value="manningKey.id">
                {{manningKey.alias}}
              </option>
            </select>
          </div>
          <div class="form-group py-1 mx-3">
            <label for="rank" class="form-control-xs font-weight-bold" >Select Rank: </label>
            <select name="rank" id="rank" class="form-control form-control-xs mx-2"
                    v-model="params.rank_id" :disabled="isLoading">
              <option :value="null" id="rankOption0" disabled selected>---Select Ranks ---</option>
              <option :value="0">ALL RANKS</option>
              <option v-for="rankKey in rankKeys"
                      :key="rankKey.id"
                      :value="rankKey.id"
                      :title="rankKey.name"
              >{{ rankKey.alias }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-10 text-center d-flex align-items-center mt-3">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li
                class="page-item"
                :class="{ disabled: pagination.currentPage === 1 }"
            >
              <button class="page-link" @click="setPage(1)">First</button>
            </li>

            <li
                v-for="page in paginationPages"
                :key="page"
                class="page-item"
                :class="{
                disabled: page === '...',
                active: page === pagination.currentPage,
              }"
            >
              <button class="page-link" @click="setPage(page)">
                {{ page }}
              </button>
            </li>

            <li
                class="page-item"
                :class="{
                disabled: pagination.currentPage === pagination.lastPage,
              }"
            >
              <button class="page-link" @click="setPage(pagination.lastPage)">
                Last
              </button>
            </li>
          </ul>
        </nav>
        <small class="mx-3">{{
            `${pagination.from} to ${pagination.to} of ${pagination.total}`
          }}</small>
      </div>
      <div class="col-2 text-center d-flex justify-content-end align-items-center">
        <button class="btn btn-primary btn-xs p-1 d-flex align-items-center"
                :disabled="params.manning_id === null && params.rank_id === null"
                v-if="!isLoading"
                @click="downloadStandbyList">
          <i class="fas fa-file-pdf fa-2x mx-1"></i>
          Generate Report
        </button>
      </div>

      <div class="col col-12">
        <table class="table table-hover table-bordered table-template-1 my-2 text-small table-striped">
          <thead>
          <tr>
            <th rowspan="2" width="1">No</th>
            <th rowspan="2">Rank</th>
            <th rowspan="2">Name</th>
            <th rowspan="2">Birthdate</th>
            <th rowspan="2">Age</th>
            <th rowspan="2">Manning</th>
            <th rowspan="2">Mobile No.</th>
            <th colspan="4">LAST VESSEL</th>
            <th colspan="3">NEXT</th>
          </tr>
          <tr>
            <th>Activity</th>
            <th>Vessel</th>
            <th>From</th>
            <th>To</th>
            <th>Activity</th>
            <th>Vessel</th>
            <th>To</th>
          </tr>
          </thead>

          <tbody class="text-small">
            <tr v-if="isLoading">
              <td colspan="100%">
                <app-loading></app-loading>
              </td>
            </tr>
          <template v-else>
            <tr v-for="(crew, index) in standbyCrewList.data" :key="crew.id">
              <td class="text-center">{{ index + 1}}</td>
              <td class="text-center">{{ crew.rank}}</td>
              <td class="text-left">
                <router-link :to="{name:'CrewActivity',params:{id:crew.id}}" target="_blank"
                             v-if="crew.fullName" class="mb-0">{{ crew.fullName }}
                </router-link>
              </td>
              <td class="text-center">{{ crew.birthdate }}</td>
              <td class="text-center">{{ crew.age}}</td>
              <td class="text-center">{{ crew.manning}}</td>
              <td class="text-center">{{  crew.mobile}}</td>
              <td class="text-center">{{  crew.currentActivity}}</td>
              <td class="text-center">{{  crew.lastVessel}}</td>
              <td class="text-center">{{  crew.currentDateFrom}}</td>
              <td class="text-center">{{  crew.currentDateTo}}</td>
              <td class="text-center">{{  crew.nextActivity}}</td>
              <td class="text-center">{{  crew.nextVessel}}</td>
              <td class="text-center">{{  crew.nextDateFrom}}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <download-pdf-loading></download-pdf-loading>
  </div>
</template>

<script>

import {vueAppMixin} from '../../../../mixins/vueAppMixin';
import {dataMixin} from '../../../../mixins/dataMixin';
import {gateMixin} from '../../../../mixins/gateMixin';
import {mapActions, mapGetters} from 'vuex';
import {DateService} from '../../../../services/Utilities/DateService';
import DownloadPDFLoading from '../../../elements/DownloadPDFLoading';
import AppLoading from '../../../elements/AppLoading';
import {ReportService} from '../../../../services/ReportService';

export default {
  name: 'GenerateStandbyCrewList',
  mixins: [ vueAppMixin, dataMixin, gateMixin ],
  components: { AppLoading,
    'download-pdf-loading': DownloadPDFLoading
  },
  data() {
    return {
      params: {
        date_from: DateService.dateToday(),
        date_to: DateService.dateToday(),
        manning_id: null,
        rank_id: null,
        page: 0
      },
      modalLoad: false
    };
  },
  methods: {
    ...mapActions([
      'getRankKeys',
      'getManningKeys',
      'getStandbyCrewList',
      'generateStandbyCrewFile',
      'setLoading'
    ]),

    async downloadStandbyList() {
      this.modalLoad = true
      document.getElementById('LoadingModal').style.display = 'block'
      !this.params.manning_id ? this.params.manning_id = '' : this.params.manning_id;
      !this.params.rank_id ? this.params.rank_id = '' : this.params.rank_id;
      await ReportService.generateStandbyCrewFile(this.params);
      this.modalLoad = false
      document.getElementById('LoadingModal').style.display = 'none'
    },

    filterStandbyCrewList() {
      this.params.page = this.pagination.currentPage;
      this.getStandbyCrewList(this.params);
    },

    async setPage(page) {
      this.pagination.currentPage = page;
      await this.filterStandbyCrewList();
    }

  },
  computed: {
    ...mapGetters([
      'rankKeys',
      'manningKeys',
      'standbyCrewList',
      'pagination',
    ]),

    paginationPages() {
      let pages = [];
      let currentPage = this.pagination.currentPage;
      let lastPage = this.pagination.lastPage;
      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },
    getManningLists(){
      return this.manningKeys.filter((manning)=>{
        return this.isKline ? ![7,17].includes(manning.id) : true
      })
    }
  },
  created() {
    this.getRankKeys();
    this.getManningKeys();
    this.setLoading(false);
  },
  watch: {
    'params.date_from'() {
      this.getStandbyCrewList(this.params);
      this.pagination.currentPage = 0;
    },
    'params.date_to'() {
      this.getStandbyCrewList(this.params);
      this.pagination.currentPage = 0;
    },
    'params.manning_id'() {
      this.getStandbyCrewList(this.params);
      this.pagination.currentPage = 0;
      document.getElementById('manningOption0').style.display = 'none'
    },
    'params.rank_id'() {
      this.getStandbyCrewList(this.params);
      this.pagination.currentPage = 0;
      document.getElementById('rankOption0').style.display = 'none'
    },
    'params.page'() {
      this.getStandbyCrewList(this.params);
      this.pagination.currentPage = 0;
    }
  },
};
</script>

<style scoped>

</style>
